import React from 'react';
import { Shield, Target, Zap } from 'lucide-react';
import { BenefitCard } from '../../components/BenefitCard';
export function KidsMartialArtsBenefits() {
  return <section className="py-24 bg-paper border-y border-subtle-gray" data-id="element-2098">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2099">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-2100">
          <h2 className="text-4xl md:text-5xl text-ink mb-6" data-id="element-2101">
            Why Families Choose Storm
          </h2>
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-2102">
          <BenefitCard icon={Shield} title="Confidence & Resilience" description="Martial arts teaches kids how to face challenges head-on, building resilience that lasts a lifetime." data-id="element-2103" />
          <BenefitCard icon={Target} title="Focus & Attention" description="Our structured environment requires active listening, helping kids improve their focus at home and in school." data-id="element-2104" />
          <BenefitCard icon={Zap} title="Fitness & Coordination" description="Get them off the screens and onto the mat with dynamic workouts that improve balance and agility." data-id="element-2105" />
        </div>
      </div>
    </section>;
}